import type { Questionnaire } from '@medplum/fhirtypes'
import {
  getComputationAnswerOptions,
  getComputationQuestionnaireItem,
  VALIDATED_TOOL_SUMMARY_ITEM,
  VALIDATED_TOOL_TAG,
} from '#src/models/questionnaires/utils/index.ts'
import { QUESTIONNAIRE_ITEM_DISPLAY_LINK_URL } from '#src/structureDefinitions.ts'

const GAD2_ANSWER_OPTIONS = getComputationAnswerOptions([
  { code: 'not-at-all', score: 0 },
  { code: 'several-days', score: 1 },
  { code: 'more-than-half-the-days', score: 2 },
  { code: 'nearly-every-day', score: 3 },
])

export const gad2Questionnaire = {
  resourceType: 'Questionnaire',
  url: 'https://www.seenhealth.org/fhir/Questionnaire/GAD-2',
  title: 'Generalized Anxiety Disorder 2-item (GAD-2)',
  name: 'GAD-2',
  status: 'active',
  subjectType: ['Patient'],
  meta: {
    tag: [VALIDATED_TOOL_TAG],
  },
  item: [
    {
      linkId: 'instructions',
      type: 'display',
      text: 'Over the last 2 weeks, how often have you been bothered by the following problems?',
    },
    {
      linkId: QUESTIONNAIRE_ITEM_DISPLAY_LINK_URL,
      type: 'display',
      text: 'GAD-2 Reference PDF',
      extension: [
        {
          url: QUESTIONNAIRE_ITEM_DISPLAY_LINK_URL,
          valueString:
            'https://depts.washington.edu/uwhatc/wp-content/uploads/2022/07/GAD-2.pdf',
        },
      ],
    },
    {
      linkId: 'nervous-anxious',
      type: 'choice',
      text: 'Feeling nervous, anxious, or on edge',
      answerOption: GAD2_ANSWER_OPTIONS,
    },
    {
      linkId: 'control-worrying',
      type: 'choice',
      text: 'Not being able to stop or control worrying',
      answerOption: GAD2_ANSWER_OPTIONS,
    },
    getComputationQuestionnaireItem([
      { code: 'negative', score: 2 },
      { code: 'positive', score: 6 },
    ]),
    VALIDATED_TOOL_SUMMARY_ITEM,
  ],
} satisfies Questionnaire

export type Gad2Category = 'Positive Screen' | 'Negative Screen'

export function gad2Category(score: number): Gad2Category | undefined {
  if (score >= 3) {
    return 'Positive Screen'
  }
  if (score >= 0 && score <= 2) {
    return 'Negative Screen'
  }
  return undefined
}
